export default __webpack_public_path__ + "static/media/PrizeDoubler_159x150.d4107b9c.png";